<template>
  <div class="carousel" ref="wrapper">
    <template v-if="list && list.length > 0">
      <ul
        class="carousel-slider"
        @touchstart.stop="moveStart($event)"
        @touchmove.stop.prevent="moving($event)"
        @touchend.stop="moveEnd($event)"
        @transitionend="checkBorder"
        :class="{ 'transtion': transtionValid }"
        :style="{ transform: 'translate3d('+ x + 'px, 0, 0)' }"
      >
        <li v-for="item in displayList" :key="item.img">
          <img :src="item.img">
        </li>
      </ul>
      <ul class="carousel-dot">
        <li
          v-for="(item, index) in dotList"
          :key="item.img"
          @click="jump(index)"
          :class="{ 'active': index === currentIndex }"
        ></li>
      </ul>
    </template>
    <img :src="img" v-else>
  </div>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.carousel {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
  width: 750px;

  img {
    width: 100%;
    height: auto;
  }

  .carousel-slider {
    display: inline-flex;

    &.transtion {
      transition: transform 200ms linear;
    }

    li {
      width: 750px;
    }
  }

  .carousel-dot {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    display: flex;
    justify-content: center;

    li {
      margin: 0 10px;
      height: 3px;
      width: 20px;
      background: #fff;
      cursor: pointer;

      &.active {
        background: $ucar_main_color;
      }
    }
  }
}
</style>

<script>
export default {
  data () {
    return {
      displayList: [],
      dotList: [],
      unitWidth: 0,
      x: 0,
      startX: 0,
      lastX: 0,
      startTime: 0,
      endTime: 0,
      transtionValid: true,
      currentIndex: 0,
      timer: null
    }
  },
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    img: {
      type: String,
      default: ''
    }
  },
  methods: {
    moveStart ({ touches }) {
      if (this.timer) clearInterval(this.timer)
      this.transtionValid = false
      this.startX = touches[0].clientX
      this.startTime = new Date().getTime()
    },
    moving ({ touches }) {
      const { clientX } = touches[0]
      const { startX, lastX, unitWidth } = this
      if (clientX < 0 || clientX > unitWidth) return
      this.x = clientX - startX + lastX
    },
    moveEnd ({ changedTouches }) {
      const {
        startX,
        startTime,
        endTime,
        unitWidth,
        currentIndex,
        AnimationBegin
      } = this
      this.endTime = new Date().getTime()
      let endX = changedTouches[0].clientX
      if (endX < 0) endX = 0
      if (endX > unitWidth) endX = unitWidth
      const distance = Math.abs(endX - startX)
      const speed = Math.abs((distance * 100) / (endTime - startTime))
      if (speed > 1 || distance > unitWidth / 2) {
        this.currentIndex =
          endX - startX < 0 ? currentIndex + 1 : currentIndex - 1
      }
      this.transtionValid = true
      this.lastX = this.x = (this.currentIndex + 1) * -unitWidth
      this.timer = AnimationBegin()
    },
    checkBorder () {
      const { unitWidth, list, x } = this
      if (x > -unitWidth || x < -list.length * unitWidth) {
        this.transtionValid = false
        this.currentIndex = x === 0 ? list.length - 1 : 0
        this.lastX = this.x = x === 0 ? -list.length * unitWidth : -unitWidth
      }
    },
    jump (index) {
      if (this.timer) clearInterval(this.timer)
      this.currentIndex = index
      this.lastX = this.x = (this.currentIndex + 1) * -this.unitWidth
      this.timer = this.AnimationBegin()
    },
    AnimationBegin () {
      return setInterval(() => {
        const { unitWidth } = this
        this.transtionValid = true
        this.currentIndex += 1
        this.lastX = this.x = (this.currentIndex + 1) * -unitWidth
      }, 2000)
    }
  },
  mounted () {
    setTimeout(() => {
      const { AnimationBegin } = this
      const list = [...this.list]
      this.unitWidth = this.$refs.wrapper.getBoundingClientRect().width
      this.x = this.lastX = -this.unitWidth
      const lastItem = list[list.length - 1]
      const firstItem = list[0]
      this.displayList = [...list]
      this.dotList = list
      this.displayList.push(firstItem)
      this.displayList.unshift(lastItem)
      this.timer = AnimationBegin()
    }, 200)
  }
}
</script>
